import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core/styles';
import { usePostHog } from 'posthog-js/react';

import { Titles } from '../../Onboarding/components/Titles/Titles';

import { Product } from '@/utils/productHelpers';
import { SelectButton } from '@/components/Button';

type Props = {
  onMyself: () => void;
  onDependent: () => void;
  /** Override the i18n key prefix. Defaults to `coverage.{product}.person_enrolling`. */
  i18nPrefix?: string;
};

type PreOnboardingParams = {
  slug: string;
  product: Product;
};

export const WhoAreYouEnrollingActivate: React.FC<Props> = ({
  onMyself,
  onDependent,
  i18nPrefix,
}) => {
  const theme = useTheme();
  const { product } = useParams<PreOnboardingParams>();
  const { t } = useTranslation();
  const prefix = i18nPrefix ?? `coverage.${product}.person_enrolling`;
  const posthog = usePostHog();

  const choiceBaseStyle: React.CSSProperties = useMemo(() => ({
    width: '100%',
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 100,
    padding: '12px 16px',
    textTransform: 'none',
    fontWeight: 600,
    justifyContent: 'center',
    borderWidth: 1.5,
  }), []);

  return (
    <div style={{ marginBottom: '40px' }}>
      <Titles
        title={t(`${prefix}.title`)}
        subtitle={t(`${prefix}.subtitle`)}
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          gap: 12,
        }}
      >
        <SelectButton
          aria-pressed={false}
          style={choiceBaseStyle}
          onClick={() => {
            posthog?.capture('DependentSelected', { 'spark.dependent': 'no' });
            onMyself();
          }}
        >
          {t(`${prefix}.myself`)}
        </SelectButton>

        <SelectButton
          aria-pressed={false}
          style={choiceBaseStyle}
          onClick={() => {
            posthog?.capture('DependentSelected', { 'spark.dependent': 'yes' });
            onDependent();
          }}
        >
          {t(`${prefix}.dependent`)}
        </SelectButton>
      </div>
    </div>
  );
};

export default WhoAreYouEnrollingActivate;
